import { Button, ButtonProps } from '@do/walrus';
import styled from 'styled-components';

export interface ButtonStyle {
  bgColor?: string;
  textColor?: string;
  hoverBgColor?: string;
  hoverTextColor?: string;
  borderColor?: string;
  hoverBorderColor?: string;
}
export interface ButtonStyleProps {
  buttonStyle?: ButtonStyle;
}

export type StyledButtonProps = ButtonProps & ButtonStyleProps;
export const StyledButton = styled(Button)<StyledButtonProps>(({ buttonStyle }) => {
  return {
    '&&': {
      backgroundColor: buttonStyle?.bgColor,
      color: buttonStyle?.textColor,
      borderColor: buttonStyle?.borderColor,

      '&:hover': {
        borderColor: buttonStyle?.hoverBorderColor,
        backgroundColor: buttonStyle?.hoverBgColor,
        color: buttonStyle?.hoverTextColor,
      },
    },
  };
});
